<template>
    <card>
        <template slot="header">
            <h3 class="card-title">Assign Memos</h3>
        </template>
        <div class="row">
            <nav>
                <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                        <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                      <router-link to="/hr/contractsmemo/">Contracts & Memos</router-link>
                    </li>
                    <li class="breadcrumb-item active">Assign Memos</li>
                </ol>
            </nav>
        </div>
        <hr style="margin-top:-10px" />
        <br/>
        <form @submit.prevent="formSubmit">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <p class="col-md-3 text-right p-text">Employee Name :</p>
                        <div class="col-md-6">
                            <div class="employee_name" :data-full_name=item.full_name>{{item.full_name}}</div>
                        </div>
                    </div>
  
                    <div class="row">
                        <p class="col-md-3 text-right p-text">Employee No :</p>
                        <div class="col-md-6">
                            <div class="employee_name" :data-emp_id=item.emp_id>{{item.emp_id}}</div>
                        </div>
                    </div>
  
                    <div class="row">
                        <p class="col-md-3 text-right p-text">Position :</p>
                        <div class="col-md-6">
                            <div class="employee_name">{{item.position_name | capitalize}}</div>
                        </div>
                    </div>
  
                    <div class="row">
                        <p class="col-md-3 text-right p-text">Department :</p>
                        <div class="col-md-6">
                            <div class="employee_name">{{item.department_name | capitalize }}</div>
                        </div>
                    </div>
  
                    <div class="row">
                        <p class="col-md-3 text-right p-text">Date Hired :</p>
                        <div class="col-md-6">
                            <div class="employee_name"><i class="fa fa-calendar"></i>&nbsp;&nbsp;{{item.employment_date}}</div>
                        </div>
                    </div>
                    <hr style="margin-top:50px" />
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="title-header">Memos</div>
                            </div>
                            <div class="col-md-4"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-6 offset-md-3">
                                <div class="upload-btn-wrapper ">
                                     <!-- Custom Button -->
                                     <button type="button" 
                                             class="btn-info btn mr-xl-2 mb-3"  
                                             @click="openFileDialog">
                                        <div v-if="files.data_files != ''">
                                            <i class="fa fa-newspaper-o"></i>&nbsp;Update Existing Memo
                                        </div>
                                        <div v-if="files.data_files == ''">
                                            <i class="fa fa-newspaper-o"></i>&nbsp;Assign Memo
                                        </div>
                                    </button>    
                                    
                                    <!-- Hidden File Input -->
                                    <input type="file" 
                                        ref="files" 
                                        id="memoFiles" 
                                        multiple 
                                        accept=".doc,.docx, .pdf" 
                                        @change="handleFileMemosUpload"
                                        style="display: none;" />

                                    <!-- Uploaded File Preview -->
                                    <div v-for="(file,key) in memoFiles" :key="key" class="mb-2">
                                        <slot v-if="file.type == 'application/pdf'">
                                            <i class="fa fa-file-pdf-o fa-2x"></i>
                                        </slot>
                                        <slot v-else-if="file.type=='application/msword'">
                                            <i class="fa fa-file-word-o fa-2x"></i>
                                        </slot> 
                                        <slot v-else-if="file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                                            <i class="fa fa-file-word-o fa-2x"></i>
                                        </slot>  
                                        &nbsp;&nbsp; {{file.name}} - {{file.size}}
                                        <span @click="removeMemoFilesUpload(key)"><i class="fa fa-close" style="color:red;cursor: pointer;"></i></span>
                                    </div>                                                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr style="margin-top:50px" v-if="files != ''"/>
                    <div v-if="files != ''" class="form-group">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="title-header">Existing Memo/s</div>
                            </div>
                            <div class="col-md-4"></div>
                        </div>
                    </div>
                    <div v-if="files != ''" class="form-group" >
                        <div class="row">
                            <div class="col-md-6 offset-md-3">
                                <div class="upload-btn-wrapper ">
                                    <div v-for="(file_item,key) in files" :key="key" class="mb-2">
                                        <div v-if="file_item.data_files != ''">
                                            <div v-for="item in file_item.data_files" :key="key" class="mb-2">
                                            <slot v-if="item.file_type == 'pdf'">
                                                    <i class="fa fa-file-pdf-o fa-2x"></i>
                                            </slot>
                                            <slot v-else-if="item.file_type=='docx'">
                                                    <i class="fa fa-file-word-o fa-2x"></i>
                                            </slot> 
                                            <slot v-else-if="item.file_type=='doc'">
                                                    <i class="fa fa-file-word-o fa-2x"></i>
                                            </slot>  
                                                    &nbsp;&nbsp; <a :href="'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + item.file_name" target="_blank">{{item.file_name}}</a>  &nbsp;&nbsp;
                                                    <i v-if="file_item.status === 'unacknowledged'" class="fa fa-eye-slash text-secondary" aria-hidden="true" v-b-tooltip.hover title="UNACKNOWLEDGED" style="font-size: 20px;cursor: pointer;"></i>
                                                    <i v-else class="fa fa-eye text-success text-big" aria-hidden="true" v-b-tooltip.hover title="ACKNOWLEDGED" style="font-size: 20px;"></i> &nbsp;&nbsp;  -  &nbsp;&nbsp;  <span class="text-secondary">Sent on: {{ new Date(file_item.date_sent).toDateString() }}</span>  
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr style="margin-top:50px" />
                    <div class="form-group"><div class="float-right"><br> <button type="submit" class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Documents</button> <br> <br></div></div>
                </div>
            </div>
        </form>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
    </card>
  </template>
  <script>
  /* eslint-disable */
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  // import {mapState} from 'vuex'
  export default {
    components: {
      Card
    },
    data() {
      return {
           item: {},
           emp_id: '',
           full_name: '',
           document_type: '',
           memoFiles: [],
           files: {},
           uploadReady:true,
           //INPUT
           file_added:'',
           error_handler:[]
        }
    },
    mounted() {
      this.getInfo()
      this.getItem()
    },
    methods: {
      getCurentUser() {
        axios.get('api/user', {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          })
          .then(response => {
            this.currentUser = response.data;
          })
          .catch(error => {
            console.log(error.response)
          });
      },
  
      getInfo() {
         axios.get('api/contractsmemo/getinfo/' + this.$route.params.id)
              .then(resp => { this.item = resp.data})
      },
      getItem(){
        axios.get('api/contractsmemo/getmemoinfo/' + this.$route.params.id)
            .then(resp => { this.files = resp.data});
     },

       openFileDialog() {
          this.$refs.files.click(); // Opens the hidden file input
       },

      //FILE UPLOAD
      handleFileMemosUpload() {
        let uploadedContractFiles = event.target.files;
        if(!uploadedContractFiles.length)
            return
        for (let i = 0; i < uploadedContractFiles.length; i++){
                this.memoFiles.push( uploadedContractFiles[i])
        }
        console.log('response => ', uploadedContractFiles)
      },

      removeMemoFilesUpload(key){
          this.memoFiles.splice(key, 1)
       },
  
        /*
      |----------------------------------------------------------------------
      |  TO SUBMIT FORM 
      |----------------------------------------------------------------------
      */
      formSubmit() {
          this.$swal({
              title: 'Are you sure?',
              text: 'Do you want to upload these documents',
              type: 'warning',
              showCancelButton: true,
              showCloseButton: false,
          })
          .then((isConfirm) => {
            if (isConfirm === true) {
                //Form data a files to upload
                let formData = new FormData()
                if (this.memoFiles.length > 0){
                    for (var i = 0; i < this.memoFiles.length; i++) {
                        let file = this.memoFiles[i];
                        formData.append('files[' + i + ']', file);
                        //   console.log(formData);
                    }
                } else {
                    this.$swal({
                        title: 'Empty document!',
                        text: 'Please upload at least one document',
                        type: 'error',
                        showCloseButton: false,
                    })
                    return;
                }
                //Additional POST Request
                  formData.append('employee_id', this.item.id)
                  formData.append('employee_name', this.item.full_name)
                  formData.append('document_type', 'memo')

                //HTTP POST Request
                  axios.post('api/uploadmemoscontracts/multiple', formData,{ 
                        headers: {
                              'Content-Type': 'multipart/form-data',
                              Authorization: "Bearer " + localStorage.getItem("token")
                          }
                      })
                    .then(resp => {
                        this.$swal('Success', 'Your request has been successfully submitted', 'success')
                        console.log(JSON.stringify(resp.data))
                    })
                    .catch(error => {
                      if (error.response.status == 422) {
                            this.error_handler = error.response.data.errors
                      }
                        console.log('response => ', error.response);
                    })
              }
          });
      }
    },
    computed: {
        filePreview(){
            let data = window.axios.defaults.baseURL + '/upload/'
            return data
        }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contracts-memo/todo-assign-memos.vue